import { Injectable } from '@angular/core';

import data from './icons.json';

@Injectable({
  providedIn: 'root',
})
export class FusuIconService {
  constructor() {}

  public getIcons(iconName: string): any {
    const icons: any[] = data.icons;
    let filter = icons.filter((icon) => icon.properties.name === iconName);

    filter = filter.map((icon) => {
      return {
        name: icon.properties.name,
        path: icon.icon.paths,
      };
    });
    return filter;
  }

  public getPaths(iconName: string): any[] {
    return data.icons.find((icon) => icon.properties.name === iconName).icon.paths;
  }

  public isFsFontset(iconName: string): boolean {
    return data.icons.filter((icon) => icon.properties.name === iconName).length > 0;
  }
}
